var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('add-edit-real',{attrs:{"commandId":_vm.commandId,"isSee":_vm.isSee},on:{"reset":_vm.reset}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }